import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import SelectResourceDrawer from './SelectResourceDrawer';

interface fSelectResourcesAsCollectionItemsProps {
  collectionID: string;
}

type ReturnData = string[] | null;

function fSelectResourcesAsCollectionItems({
  collectionID,
}: fSelectResourcesAsCollectionItemsProps): Promise<ReturnData> {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <SelectResourceDrawer
        collectionID={collectionID}
        onConfirm={(resourceIDs) => {
          resolve(resourceIDs);
        }}
        onClosed={() => {
          setTimeout(() => {
            resolve(null);
            root.unmount();
            div.remove();
          }, 1);
        }}
      />,
    );
  });
}

export default fSelectResourcesAsCollectionItems;
